const { pipe, or, when, always } = require('ramda');
const { useSelector } = require('react-redux');

const { isLoginAsSelector } = require('store/auth/selectors');
const { isAgentSelector, isSuperAdminSelector } = require('store/user/selectors');

const useAssetsPermissions = () => {
  const isAgent = useSelector(isAgentSelector);
  const isOverriding = useSelector(isLoginAsSelector);
  const isSuperAdmin = useSelector(isSuperAdminSelector);

  const withAssetSettings = pipe(or(isOverriding), or(isSuperAdmin), when(always(isAgent), always(false)))();

  return { withAssetSettings };
};

export default useAssetsPermissions;
